<template>
  <v-card>
    <v-carousel
        cycle
        interval="2500"
        height="450"
        hide-delimiter-background
        show-arrows-on-hover
    >
      <v-carousel-item v-for="(item, index) in itemsCarousel" :key="index">
        <v-responsive>
          <v-img
              gradient="to right, rgba(0,0,0,.9), rgba(0,0,0,0.05)"
              :src="item.image"
              min-height="450px">
            <v-spacer></v-spacer>


            <v-spacer></v-spacer>

          </v-img>
        </v-responsive>
      </v-carousel-item>
    </v-carousel>

  </v-card>
</template>

<script>
import ERole from "@/models/e-role";
export default {
  name: 'HomeBidangMainCarousel',
  props:{
    itemsCarousel: [],
  },
  data() {
    return {
    }
  },
  computed:{
    currentUserWebinar(){
      if(this.$store.state.auth.user){
        return !!this.$store.state.auth.user.roles.includes(ERole.ROLE_USER);
      } else {
        return false
      }
    },
  },
  methods: {
  },
  created() {
  }
}

</script>

<style scoped>

</style>